declare namespace $ {

	type $mol_link__title_shm_projects_module_card_1 = $mol_type_enforce<
		ReturnType< $shm_projects_module_card['module_id'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_projects_module_card_2 = $mol_type_enforce<
		ReturnType< $shm_projects_module_card['module_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_text__text_shm_projects_module_card_3 = $mol_type_enforce<
		ReturnType< $shm_projects_module_card['description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_projects_module_card extends $mol_view {
		module_arg( ): Record<string, any>
		Title( ): $mol_link
		description( ): string
		Description( ): $mol_text
		module_id( ): string
		project_id( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map